export function setCanonical(path) {
  const link = document.getElementById('canonical-link');
  if (link) {
    link.href = `https://legasecure.net${path}`;
  }
}

export function setMeta(title, description) {
  document.title = title;
  const desc = document.querySelector('meta[name="description"]');
  if (desc) desc.setAttribute('content', description);
}
